import { getAuditsList } from "../api-server/audits";
import { getIncidentReportList } from "../api-server/incident_report";
import { getLessonLearnedList } from "../api-server/lesson_learned";
import { getMoCList } from "../api-server/moc";
import { getNonConformanceList } from "../api-server/non_conformance";
import { getOFIList } from "../api-server/ofi";
import { TReportType } from "../../types/reporting.types";

const REPORT_LIST_FETCHERS: Record<
	TReportType,
	(filter: any) => Promise<unknown>
> = {
	audit: getAuditsList,
	incident_report: getIncidentReportList,
	moc: getMoCList,
	ofi: getOFIList,
	non_conformance: getNonConformanceList,
	lesson_learned: getLessonLearnedList,
};

/** One report by id, or null when it does not exist. */
export const fetchReportById = async (
	type: TReportType,
	reportId: string
): Promise<any> => {
	const reports: any = await REPORT_LIST_FETCHERS[type]({ _id: reportId });
	return reports?.[0] ?? null;
};

export const fetchReportingHubReports = (
	type: TReportType,
	currentTenantKey: string,
	isMasterTenant: boolean
): Promise<any[]> => {
	const operatorFilter = isMasterTenant ? {} : { operator: currentTenantKey };

	switch (type) {
		case "incident_report":
			return getIncidentReportList(
				{ status: { $ne: "draft" }, ...operatorFilter },
				{ status: -1, modified_on: -1 }
			) as Promise<any[]>;
		case "audit":
			return getAuditsList(
				{
					status: { $ne: "draft" },
					$or: [
						{ internal_report: false },
						{ internal_report: true, ...operatorFilter },
					],
				},
				{ status: -1, modified_on: -1 }
			) as Promise<any[]>;
		case "moc":
		case "ofi":
		case "non_conformance": {
			const fetchers: Record<
				string,
				(filter: any, sort: any) => Promise<unknown>
			> = {
				moc: getMoCList,
				ofi: getOFIList,
				non_conformance: getNonConformanceList,
			};
			return fetchers[type](
				{ status: { $ne: "draft" }, ...operatorFilter },
				{ status: -1, modified_on: -1 }
			) as Promise<any[]>;
		}
		default:
			return Promise.resolve([]);
	}
};
